<template>
	<section class="worker_form">

		<div>{{model.user_first_name}} {{model.user_last_name}}</div>

		<div class="field">
			<label for="field012">Пользователь</label>
			<select id="field012" v-model="model.user_id">
				<option v-for="user in users" :value="user._id">{{user.first_name}} {{user.last_name}}</option>
			</select>
		</div>

		<div class="field">
			<label for="field022">Клиника</label>
			<select id="field022" v-model="model.clinic_id">
				<option v-for="clinic in clinics" :value="clinic._id">{{clinic.name}}</option>
			</select>
		</div>

		<div class="field">
			<label for="field02">Роль</label>
			<select id="field02" v-model="model.role_id">
				<option v-for="role in roles" :value="role._id">{{role.name}}</option>
			</select>
		</div>

		<div class="field">
			<label for="field01">Должность</label>
			<input type="text" id="field01" v-model="model.position">
		</div>

		<div class="field">
			<label for="field03">Принимает?</label>
			<select id="field03" v-model="model.can">
				<option value="yes">Да</option>
				<option value="no">Нет</option>
				<option value="by_request">По заявкам</option>
			</select>
		</div>

		<div class="field check_field">
			<label>Тип</label>
			<input class="type_check" type="checkbox" v-model="model.type" value="adult">
			<div class="forCheck">Взрослый</div>
			<input class="type_check" type="checkbox" v-model="model.type" value="childish">
			<div class="forCheck">Детский</div>
		</div>

		<div class="field">
			<label for="field05">Статус</label>
			<select id="field05" v-model="model.status">
				<option value="created">Создан</option>
				<option value="blocked">Заблокирован</option>
			</select>
		</div>

		<div class="field">
			<label for="field06">Время</label>
			<input type="number" id="field06" v-model="model.time">
		</div>
	</section>
</template>

<script>
	export default {
		name: "WorkerForm",
		props: ['model'],
		mounted() {
			this.$store.dispatch('role/list', {}).then(response => this.roles = response.data)

			this.$store.dispatch('user/byName', '').then(response => this.users = response)

			this.$store.dispatch('clinic/list', {
				per_page: 100
			}).then(response => this.clinics = response.data)

			this.model.type = this.model.type || []
		},
		data() {
			return {
				roles: [],
				users: [],
				clinics: []
			}
		}
	}
</script>

<style scoped lang="scss">
	.check_field {
		input {
			height: auto;
		}
	}

	select {
		width: 170px;
	}

	.forCheck {
		width: 70px;
		display: inline-block;
		line-height: 20px;
	}
</style>



// WEBPACK FOOTER //
// WorkerForm.vue?85dcadb4